export { default } from './ViewForecastTravel';
